import { Extension } from "@tiptap/core";

import { mirrorColor } from "../utils/color";

import type { Color } from "@corca/data";

export type BlockStyleOptions = {
  types: string[];
};

export const BLOCK_STYLE_TYPES = ["callout"];

declare module "@tiptap/core" {
  interface Commands<ReturnType> {
    blockStyle: {
      setBackgroundColor: (backgroundColor: Color) => ReturnType;
      unsetBackgroundColor: () => ReturnType;
    };
  }
}

export const BlockStyle = Extension.create<BlockStyleOptions>({
  name: "blockStyle",

  addOptions() {
    return {
      types: BLOCK_STYLE_TYPES,
    };
  },

  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          color: {
            default: null,
            renderHTML({ color }: { color?: Color }) {
              if (color) {
                return {
                  color,
                  class: `bg-${color} dark:bg-${mirrorColor(color)}`,
                };
              }

              return null;
            },
          },
        },
      },
    ];
  },

  addCommands() {
    return {
      setBackgroundColor:
        (backgroundColor) =>
        ({ commands }) => {
          return this.options.types
            .map((type) => commands.updateAttributes(type, { color: backgroundColor }))
            .every((response) => response);
        },

      unsetBackgroundColor:
        () =>
        ({ commands }) => {
          return this.options.types
            .map((type) => commands.resetAttributes(type, "color"))
            .every((response) => response);
        },
    };
  },
});
